<template>
  <v-layout id="account" align-content-start row wrap justify-center>
    <v-flex xs12 lg8>
      <v-layout class="section-header" row wrap align-content-center justify-center>
        <v-flex xs12>
          <h1 class="section-title">
            <v-icon color="deep-orange darken-2">fal fa-user-circle</v-icon>
            <span v-show="completeAccount">Complete seu cadastro</span>
            <span v-show="!completeAccount">Editar conta</span>
          </h1>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 lg8>
      <v-stepper v-model="currentStep">
        <v-stepper-header class="elevation-1">
          <v-stepper-step :complete="currentStep > 1" step="1" :editable="currentStep >= 2 || !completeAccount"
            complete-icon="fal fa-check" edit-icon="fal fa-check" color="grey lighten-1">
            Informações gerais
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="currentStep > 2" :editable="currentStep >= 2 || !completeAccount"
            complete-icon="fal fa-check" edit-icon="fal fa-check" color="grey lighten-3">
            Informações de contato
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="currentStep > 2" :editable="!completeAccount"
            complete-icon="fal fa-check" edit-icon="fal fa-check">
            Senha e foto do perfil
          </v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-layout wrap>
              <v-flex xs12 md6>
                <v-text-field label="Nome" v-model="user.first_name" required></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Sobrenome" v-model="user.last_name" required></v-text-field>
              </v-flex>

              <v-flex xs12 md4>
                <v-menu ref="birthDatePicker" :close-on-content-click="false"
                  v-model="birthDatePicker" :nudge-right="40" lazy transition="scale-transition"
                  offset-y full-width max-width="290px" min-width="290px">
                  <v-text-field slot="activator" v-model="dateFormatted" label="Data de nascimento"
                    hint="DD/MM/AAAA" persistent-hint @blur="date = parseDate(dateFormatted)"></v-text-field>
                  <v-date-picker locale="pt-br" v-model="date" no-title
                    @input="birthDatePicker = false" prev-icon="fal fa-angle-left"
                    next-icon="fal fa-angle-right"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 md4>
                <v-select :items="gender" item-text="name" item-value="value" v-model="user.gender"
                  append-icon="fal fa-chevron-down" label="Gênero" single-line required></v-select>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field label="Estatura (cm)" mask="###" :hint="user.stature ? user.stature + 'cm' : ''"
                  v-model="user.stature" required></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field label="RG" v-model="user.document" required></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="CPF" mask="###.###.###-##" v-model="user.document_number" required></v-text-field>
              </v-flex>
            </v-layout>
            <p class="text-xs-right">
              <v-btn round large depressed color="success" :loading="loadingRequest"
                @click.stop="save(2)">
                Avançar
              </v-btn>
            </p>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-layout wrap>
              <v-flex xs12 md6>
                <v-text-field label="Telefone" v-model="user.phones[0]"
                  mask="(##) #####-####" return-masked-value required></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="CEP" v-model="address.zip" @keyup.native="findAddress(address.zip)"
                  mask="#####-####" required></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-autocomplete :items="states" v-model="address.state"
                  append-icon="fal fa-chevron-down" label="Estado" single-line required></v-autocomplete>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Cidade" v-model="address.city" required></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-text-field label="Rua" v-model="address.street" required></v-text-field>
              </v-flex>

              <v-flex xs12 md6>
                <v-text-field label="Bairro" v-model="address.neighborhood" required></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field label="Complemento" v-model="address.complement"></v-text-field>
              </v-flex>

            </v-layout>
            <p class="text-xs-right">
              <v-btn round large depressed color="success" :loading="loadingRequest"
                @click.stop="save(3)">
                Avançar
              </v-btn>
            </p>
          </v-stepper-content>
          <v-stepper-content step="3">
            <v-layout row>
              <v-flex xs12>
                <file-input accept="image/*" ref="fileInput" :value="avatar"
                  @input="getUploadedFile"></file-input>
              </v-flex>
            </v-layout>
            <v-layout align-content-start row wrap justify-center>
              <v-flex xs12 md8>
                <v-text-field prepend-icon="fal fa-lock" v-model="password"
                label="Senha" :append-icon="hidePassword ? 'fal fa-eye-slash' : 'fal fa-eye'"
                @click:append="() => (hidePassword = !hidePassword)"
                :type="hidePassword ? 'password' : 'text'"></v-text-field>
              </v-flex>
            </v-layout>
            <p class="text-xs-right">
              <v-btn round large depressed color="success" :loading="loadingRequest"
                @click.stop="save(4)">
                Avançar
              </v-btn>
            </p>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>

<script>
import EventBus from '@/event-bus'
import router from '@/router'
import axios from 'axios'
import FileInput from '@/modules/FileInput'
import { Auth, Storage } from 'aws-amplify'

export default {
  name: 'Account',
  data: () => ({
    avatar: null,
    hidePassword: true,
    currentStep: 1,
    loadingRequest: false,
    isNewAddress: true,
    date: null,
    dateFormatted: null,
    birthDatePicker: false,
    password: undefined,
    user: JSON.parse(localStorage.getItem('currentUser')),
    address: {},
    completeAccount: false,
    findAddressTimeout: null,
    states: ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RO', 'RS', 'RR', 'SC', 'SE', 'SP', 'TO'],
    gender: [
      { name: 'Masculino', value: 'male' },
      { name: 'Feminino', value: 'female' }
    ]
  }),

  methods: {
    getUploadedFile (e) {
      this.avatar = e
    },

    updateCurrentUser (status, avatar) {
      let currentUser = JSON.parse(localStorage.getItem('currentUser'))

      currentUser.status = status
      currentUser.avatar = avatar

      localStorage.removeItem('currentUser')
      localStorage.setItem('currentUser', JSON.stringify(currentUser))
    },

    uploadAvatar () {
      EventBus.$emit('appLoading', true)
      const file = this.avatar
      const customPrefix = { public: 'users/' }

      Storage.put(`${this.user._id}-${this.$moment().unix()}`, file, { customPrefix })
        .then(data => {
          const avatarURL = `https://s3.amazonaws.com/mentor-fit/users/${data.key}`
          this.updateCurrentUser('active', avatarURL)

          // eslint-disable-next-line
          axios.put(`${API.users}/${this.user._id}`, { avatar: avatarURL, status: 'active' }).then(response => {
            this.redirectToUser()
          }).catch(errors => {
            this.redirectToUser()
          })
        })
    },

    redirectToUser () {
      EventBus.$emit('appLoading', false)
      if (this.$route.params.id) {
        router.push({ name: 'AdminUserShow', params: { id: this.$route.params.id } })
      } else {
        router.push({ path: '/' })
      }
    },

    loadAddress () {
      EventBus.$emit('appLoading', true)

      // eslint-disable-next-line
      axios.get(`${API.userAddresses}/users/${this.user._id}`).then(response => {
        if (response.data.addresses && response.data.addresses[0]) {
          this.address = response.data.addresses[0]
          this.isNewAddress = false
        } else {
          this.address = {}
          this.isNewAddress = true
        }

        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Ocorreu um erro ao carregar o endereço',
          color: 'error'
        })
      })
    },

    findAddress (zipcode) {
      if (!zipcode || !zipcode.length || zipcode.length < 8) return
      const path = `https://viacep.com.br/ws/${zipcode}/json/`

      if (this.findAddressTimeout) {
        clearTimeout(this.findAddressTimeout)
        this.findAddressTimeout = null
      }

      this.findAddressTimeout = setTimeout(() => {
        const authorization = axios.defaults.headers.common['Authorization']
        delete axios.defaults.headers.common['Authorization']

        axios.get(path).then(response => {
          axios.defaults.headers.common['Authorization'] = authorization
          if (!response.data || response.data.erro) return
          const address = response.data
          this.address = {}
          this.address.zip = zipcode
          if (address.logradouro) this.address.street = address.logradouro
          if (address.bairro) this.address.neighborhood = address.bairro
          if (address.localidade) this.address.city = address.localidade
          if (address.uf) this.address.state = address.uf
        }).catch(() => {
          axios.defaults.headers.common['Authorization'] = authorization
        })
      }, 500)
    },

    loadUser () {
      EventBus.$emit('appLoading', true)

      if (!this.user.phones) this.user.phones = []

      let userId

      if (this.$route.params.id) {
        userId = this.$route.params.id // complete signup
      } else {
        userId = this.user._id // edit user account
      }

      // eslint-disable-next-line
      axios.get(`${API.users}/${userId}`).then(response => {
        this.user = response.data.user
        if (this.user.birthday) this.date = this.user.birthday.replace('T00:00:00.000Z', '')
        this.loadAddress()
        this.loadAvatar()
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', {
          message: 'Ocorreu um erro inesperado',
          color: 'error'
        })
      })
    },

    loadAvatar () {
      if (this.user.avatar) {
        this.avatar = this.user.avatar
      }
    },

    validateAddress (address) {
      return address && (address.street || address.zip || address.city || address.state)
    },

    saveAddress () {
      this.loadingRequest = true
      let request

      if (!this.validateAddress(this.address)) return

      if (this.isNewAddress) {
        // eslint-disable-next-line
        request = axios.post(`${API.userAddresses}/users/${this.user._id}`, this.address)
      } else {
        // eslint-disable-next-line
        request = axios.put(`${API.userAddresses}/${this.address._id}`, this.address)
      }

      request.then(response => {
        this.loadingRequest = false
      }).catch(errors => {
        this.loadingRequest = false
      })
    },

    save (step) {
      this.loadingRequest = true

      if (this.date) this.user.birthday = this.date
      if (this.address) this.saveAddress()

      if (this.password) {
        Auth.currentAuthenticatedUser().then(user => {
          return Auth.changePassword(user, user.attributes['custom:temp_pass'], this.password)
        }).then(data => console.log(data)).catch(err => console.log(err))
      }

      // eslint-disable-next-line
      axios.put(`${API.users}/${this.user._id}`, this.user).then(response => {
        this.loadingRequest = false
        this.currentStep = step

        if (step === 4) {
          if (typeof this.avatar !== 'string') {
            this.uploadAvatar()
          } else {
            this.currentStep = 3
          }
        } else if (step === 3) {
          this.updateCurrentUser('active', '')
          axios.put(`${API.users}/${this.user._id}`, { status: 'active' })
        }
      }).catch(errors => {
        this.loadingRequest = false
        EventBus.$emit('showSnackbar', {
          message: 'Ocorreu um erro ao salvar o perfil',
          color: 'error'
        })
      })
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },

  watch: {
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
    }
  },

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },

  created () {
    this.loadUser()

    if (this.$route.params.completeAccount) {
      this.completeAccount = true
    }

    if (this.$route.params.currentStep) {
      this.currentStep = this.$route.params.currentStep
    }
  },

  components: {FileInput}
}
</script>



// WEBPACK FOOTER //
// src/components/Account.vue